"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DropMenu = require("./partials/DropMenu");
var _Footer = require("./partials/Footer");
var _Menu = require("./Menu.styles");
var _hooks = require("../../hooks");
var _OffsetBox = require("../../Layout/OffsetBox");
var _useOffsetBox2 = require("../../Layout/OffsetBox/useOffsetBox");
var _Button = require("../Button");
var _OffsetBoxDropCard = require("../partials/OffsetBoxDropCard");
var _Card = require("../Card");
var _Header = require("./partials/Header");
var _Portal = require("../../Layout/Portal");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Menu = /*#__PURE__*/(0, _react.forwardRef)(function (props, outerRef) {
  var _btnProps$customStyle;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var id = props.id,
    defaultTitle = props.defaultTitle,
    btnProps = props.btnProps,
    _props$anchorWidth = props.anchorWidth,
    anchorWidth = _props$anchorWidth === void 0 ? 'fit-content' : _props$anchorWidth,
    _props$options = props.options,
    options = _props$options === void 0 ? undefined : _props$options,
    children = props.children,
    _props$position = props.position,
    position = _props$position === void 0 ? 'bottom' : _props$position,
    _props$isAttachedToWi = props.isAttachedToWindow,
    isAttachedToWindow = _props$isAttachedToWi === void 0 ? isMobileView : _props$isAttachedToWi,
    _props$isFullScreen = props.isFullScreen,
    isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen,
    _props$isWithActionBu = props.isWithActionButtons,
    isWithActionButtons = _props$isWithActionBu === void 0 ? false : _props$isWithActionBu,
    isOpenOnFocus = props.isOpenOnFocus,
    _props$isBoxCenteredT = props.isBoxCenteredToAnchor,
    isBoxCenteredToAnchor = _props$isBoxCenteredT === void 0 ? false : _props$isBoxCenteredT,
    onCancel = props.onCancel,
    onConfirm = props.onConfirm,
    onBoxAnimationComplete = props.onBoxAnimationComplete;
  var _useOffsetBox = (0, _useOffsetBox2.useOffsetBox)(isOpenOnFocus, onCancel),
    anchorRef = _useOffsetBox.anchorRef,
    dropContentRef = _useOffsetBox.dropContentRef,
    handleAnchorFocus = _useOffsetBox.handleAnchorFocus,
    handleAnchorKeyUp = _useOffsetBox.handleAnchorKeyUp,
    isOpen = _useOffsetBox.isOpen,
    toggle = _useOffsetBox.toggle,
    close = _useOffsetBox.close,
    open = _useOffsetBox.open;
  var _useState = (0, _react.useState)(position),
    _useState2 = _slicedToArray(_useState, 2),
    actualBoxPosition = _useState2[0],
    setActualBoxPosition = _useState2[1];
  var styles = (0, _Menu.useStyles)(props, isOpen);
  var handleBoxPositionChange = function handleBoxPositionChange(pos) {
    setActualBoxPosition(pos);
  };
  (0, _react.useImperativeHandle)(outerRef, function () {
    return {
      closeMenu: function closeMenu() {
        close();
      },
      toggleMenu: function toggleMenu() {
        toggle();
      },
      openMenu: function openMenu() {
        open();
      }
    };
  });
  var handleCancel = (0, _react.useCallback)(function (event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    if (onCancel) {
      onCancel();
    }
    close();
  }, [close, onCancel]);
  var handleConfirm = (0, _react.useCallback)(function (event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    if (onConfirm) {
      onConfirm();
    }
    close();
  }, [close, onConfirm]);
  var handleClick = function handleClick(e) {
    toggle();
    if (btnProps.onClick) {
      btnProps.onClick(e);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isAttachedToWindow && isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Menu-mask']
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Menu'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBox.OffsetBox, {
        isAttachedToWindow: isAttachedToWindow,
        isCenteredToAnchor: isBoxCenteredToAnchor,
        position: position,
        isOpen: isOpen,
        onBoxPositionChange: handleBoxPositionChange,
        anchorWidth: anchorWidth,
        anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, _objectSpread(_objectSpread({
          id: id ? "button-".concat(id) : 'ccMenuButton',
          ref: anchorRef
        }, btnProps), {}, {
          onClick: handleClick,
          onFocus: handleAnchorFocus,
          onKeyUp: handleAnchorKeyUp
        })),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OffsetBoxDropCard.OffsetBoxDropCard, {
          id: id !== null && id !== void 0 ? id : 'ccMenuDropdown',
          ref: dropContentRef,
          position: actualBoxPosition,
          isAttachedToWindow: isAttachedToWindow,
          isFullScreen: isFullScreen,
          width: btnProps === null || btnProps === void 0 ? void 0 : (_btnProps$customStyle = btnProps.customStyle) === null || _btnProps$customStyle === void 0 ? void 0 : _btnProps$customStyle.width,
          onClose: isWithActionButtons ? handleCancel : close,
          onAnimationComplete: onBoxAnimationComplete,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card.Section, {
            size: "small",
            flexValues: {
              flexGrow: 1
            },
            children: [isMobileView && isWithActionButtons && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.Header, {
              label: defaultTitle !== null && defaultTitle !== void 0 ? defaultTitle : btnProps.children,
              onCancel: handleCancel
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropMenu.DropMenu, {
              options: options,
              isFullScreen: isFullScreen,
              closeMethod: close,
              isWithActionButtons: isWithActionButtons,
              children: children
            })]
          }), isWithActionButtons && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.Footer, {
            onCancel: handleCancel,
            onConfirm: handleConfirm
          })]
        })
      })
    })]
  });
});
exports.Menu = Menu;